export { DEFAULT_LANGUAGE, LANGUAGES, isLanguage, resolveLanguage, translate } from './catalogue'
export type { Catalogue, Language, TranslationKey } from './catalogue'
export { LocalizationProvider, useLocalization, useTranslate } from './provider'
export type { Translate } from './provider'

import type { TranslationKey } from './catalogue'
import { resolveLanguage as resolve, translate as render } from './catalogue'

export function systemTranslate(
  key: TranslationKey,
  params?: Record<string, string | number>,
): string {
  return render(resolve(navigator.language), key, params)
}
